export const calPercent = (value) =>
  Math.min(100, Math.max(0, Number(value) || 0));

export const formatDisplayNumber = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") return value.toLocaleString("en-US");
  if (
    typeof value === "string" &&
    value.trim() !== "" &&
    Number.isFinite(Number(value))
  )
    return Number(value).toLocaleString("en-US");
  return String(value);
};

export const calculatePercent = (count, total) =>
  total > 0 ? Math.round((count / total) * 100) : 0;

